export default __webpack_public_path__ + "static/media/3.020f4aa5.mp4";